<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
        <div class="text-center d-flex flex-column align-center justify-center">
          <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118"/>
          <h3 class="mt-4 green--text">در حال ذخیره‌سازی خودکار اطلاعات سامانه حضور و غیاب...</h3>
          <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
        </div>
      </v-overlay>

      <v-row class="pa-2" no-gutters>
        <!-- تب‌های کنترل پیش‌نمایش و QR -->
        <v-col class="pa-2 mb-4 sticky-md" cols="12" md="4" style="top: 12px">
          <v-tabs
            v-model="qrShow"
            background-color="grey lighten-3 pa-1"
            class="rounded-pill mx-auto pa-1"
            color="primary"
            height="48"
            style="width: fit-content"
          >
            <v-tab :disabled="e6 <= 1" :ripple="true">
              <v-icon left small>mdi-qrcode</v-icon>
              مشاهده QR
            </v-tab>
            <v-tab :ripple="true">
              <v-icon left small>mdi-cellphone</v-icon>
              پیش‌نمایش فرم
            </v-tab>
            <v-tab :ripple="true" :disabled="e6 <= 1">تعرفه‌ها</v-tab>
          </v-tabs>
        </v-col>

        <v-col v-show="$vuetify.breakpoint.mdAndUp" cols="8" />

        <!-- سایدبار پیش‌نمایش و بارکدساز -->
        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 100px; height: fit-content"
        >
          <v-tabs-items
            v-model="qrShow"
            class="overflow-visible mb-4 mb-md-0"
            touchless
          >
            <!-- تب ساخت و دانلود کیوآر -->
            <v-tab-item>
              <qr-maker :loading="loading" />
              <v-btn class="btn-download" @click="showDialog = true">
                <v-icon left>mdi-progress-download</v-icon>
                {{ $t("download_qr") }}
              </v-btn>
            </v-tab-item>

            <!-- پیش‌نمایش موبایل برای فرم ثبت حضور و غیاب پرسنل -->
            <v-tab-item>
              <AttendanceQrView v-model="cardTexts" :qr-svg-data-url="qrSvgDataUrl"/>
            </v-tab-item>

            <!-- تعرفه‌ها -->
            <v-tab-item v-if="!!info?.id && e6 > 1">
              <Tariffs :id_qr="info.id" :qrtype="'attendanceqr'" />
            </v-tab-item>
          </v-tabs-items>
        </v-col>

        <!-- بدنه استپر پیکربندی کیوآر حضور و غیاب -->
        <v-col cols="12" md="8">
          <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
            <!-- مرحله ۱: نام کیوآر و آدرس یکتا -->
            <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
              <div class="row justify-center">
                <div class="col-md-12">
                  <p class="font-weight-bold">وارد کردن اطلاعات کیوآر کد حضور و غیاب</p>
                </div>

                <div class="col-md-6 mt-0 pt-0 rowinfo">
                  <v-text-field
                    v-model="cardTexts.visitName"
                    :disabled="e6 > 1"
                    append-icon="mdi-briefcase-check"
                    class="mt-0 pt-0 contentinfo"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    label="عنوان ایستگاه / فرم حضور و غیاب *"
                    placeholder="مثال: کیوآر ثبت تردد - شعبه مرکزی"
                    outlined
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-visitName`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    label="عنوان کیوآر"
                  />
                </div>

                <div class="col-md-6 mt-0 pt-0 rowinfo">
                  <qr-address-field
                    id="qr-address"
                    ref="address-field"
                    v-model="dtUrl"
                    :disabled="e6 > 1"
                    :error-messages="errors['identifier']"
                    append-icon="mdi-web"
                    class="mt-0 pt-0 contentinfo"
                    dense
                    outlined
                    persistent-hint
                    @updateDest="domainId = $event"
                    :key="$t('qrAddressUpdate.hints.allowedChars')"
                    :hint="$t('qrAddressUpdate.hints.allowedChars')"
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-dtUrl`"
                    label="شناسه آدرس کیوآر"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                  />
                </div>
              </div>
            </v-stepper-step>

            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
              <div class="col-md-12">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="markQr"
                />
              </div>
            </v-stepper-content>

            <!-- مرحله ۲: ویرایش اطلاعات شرکت، دکمه‌های تردد، فیلدها و ظاهر -->
            <v-stepper-step :complete="e6 > 2" class="px-0 px-md-4" step="2">
              تنظیمات شرکت، عملیات تردد، فیلدهای پرسنل و ظاهر
            </v-stepper-step>

            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="2">
              <div class="mb-4">
                <div class="d-flex align-center">
                  <v-switch
                    v-model="AutoSave"
                    color="primary"
                    class="mt-0 pt-0 shrink"
                    hide-details
                    label="ذخیره خودکار"
                  ></v-switch>

                  <v-tooltip bottom max-width="340">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        x-small
                        class="mr-1"
                        v-bind="attrs"
                        v-on="on"
                        @click.stop
                      >
                        <v-icon small color="grey darken-1">
                          mdi-help-circle-outline
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>
                      تغییرات با بسته شدن هر آکاردئون به‌صورت آنی ذخیره می‌گردند.
                    </span>
                  </v-tooltip>
                </div>

                <div
                  v-if="$vuetify.breakpoint.xsOnly"
                  class="text-caption grey--text text--darken-1 mt-1 pr-1"
                  style="line-height: 1.4"
                >
                  تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود.
                </div>
              </div>

              <!-- رندر داینامیک کامپوننت‌ها از طریق list-expansion -->
              <list-expansion
                v-model="cardTexts"
                :components="specialInfo"
                :data="cardTexts"
                :info="info"
                :service-name="serviceName"
                :component-name="componentName"
                @save-required="AutoSave && qrUpdate(false)"
                flat
              />

              <next-btn
                :loading="loading"
                style="background: #1b8d39"
                @click="qrUpdate(true)"
              />
            </v-stepper-content>
          </v-stepper>

          <!-- رندر پشت‌صحنه ساخت فایل SVG بارکد -->
          <div class="d-none">
            <qr-code-make
              ref="qrCanvas"
              v-model="qrDesign"
              :file.sync="qrSvgDataUrl"
              :link="fullLink"
              @save="qrDesign = $event"
            />
          </div>

          <!-- پاپ‌آپ دانلود QR -->
          <custom-popup
            v-model="showDialog"
            :cons="cons"
            hide-confirm
            max-width="900"
            transition="dialog-bottom-transition"
          >
            <template v-slot:helpinfo>
              <help-info
                :element-name="`${serviceName}-${componentName}-data-show-download-d`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="دانلود کیوآر"
              />
            </template>
            <v-card class="pa-5">
              <download-file-with-api
                v-if="showDialog"
                :address="`${info?.domain?.name || 'qrland.in/'}${info?.identifier}`"
                :visit-name="cardTexts.visitName"
                :qr_id="info?.qrId"
              />
            </v-card>
          </custom-popup>
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import HelpInfo from "../../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import QrMaker from "@/view/pages/qrland/components/qrMaker.vue";
import QrAddressField from "@/view/content/fragments/qrAddressField.vue";
import ListExpansion from "@/view/content/fragments/listExpansion.vue";
import NextBtn from "@/view/content/fragments/nextBtn.vue";
import QrCodeMake from "@/view/pages/qrland/qrCodeStyle/qrCodeMake.vue";
import DownloadFileWithApi from "@/view/pages/qrland/downloadFileWithApi.vue";
import Tariffs from "../../../components/Tariffs/Tariffs.vue";
import { AtomSpinner } from "epic-spinners";
import { mapActions } from "vuex";
import { getLanguageCookie } from "../../../../core/plugins/TitleRibbon/utils/languageCookie";
import AttendanceQrView from "./components/attendanceQrView.vue";

export default {
  name: "AttendanceQr",

  components: {
    HelpInfo,
    HelpInfoWrapper,
    DownloadFileWithApi,
    QrCodeMake,
    NextBtn,
    ListExpansion,
    QrAddressField,
    QrMaker,
    Tariffs,
    AtomSpinner,
    AttendanceQrView
  },

  data() {
    return {
      isAutoSaving: false,
      AutoSave: false,
      helpData: [],
      serviceName: "Qrland",
      componentName: "attendanceqr",
      e6: 1,
      qrShow: 1,
      domainId: null,
      createdDomain: null,
      createdId: null,
      dtUrl: null,
      showDialog: false,
      loading: false,
      finish: true,
      errors: {},
      qrDesign: {},
      cons: { title: "دانلود کیوآر کد حضور و غیاب" },
      info: null,

      cardTexts: {
        visitName: "فرم ثبت حضور و غیاب پرسنل",

        // تنظیمات دکمه‌ها و کلیدهای تردد
        AttendanceActionSettings: {
          actions: [
            {
              id: "check_in",
              label: "ثبت ورود پرسنل",
              icon: "mdi-fingerprint",
              color: "success",
              active: true,
              outlined: false
            },
            {
              id: "check_out",
              label: "ثبت خروج پرسنل",
              icon: "mdi-fingerprint",
              color: "error",
              active: true,
              outlined: true
            },
            {
              id: "traffic",
              label: "ثبت تردد آزاد",
              icon: "mdi-swap-horizontal",
              color: "primary",
              active: false,
              outlined: true
            },
            {
              id: "hourly_leave",
              label: "مرخصی ساعتی",
              icon: "mdi-clock-out",
              color: "warning",
              active: false,
              outlined: true
            },
            {
              id: "mission",
              label: "ثبت ماموریت",
              icon: "mdi-briefcase-check",
              color: "info",
              active: false,
              outlined: true
            }
          ]
        },

        // فیلدهای فرم ثبت‌نام پرسنل (بدون conform و با ساختار جدید رگولار اکسپرشن)
        AttendanceRegistrationFields: {
          items: [
            {
              id: 3001,
              title: "شماره پرسنلی",
              label: "شماره پرسنلی",
              action: "mdi-badge-account-horizontal",
              items: [
                {
                  title: "شماره پرسنلی",
                  label: "شماره پرسنلی",
                  placeholder: "مثال: 1042",
                  optional: false,
                  action: true,
                  type: "number",
                  setting: {
                    regex: ["number"],
                    min: null,
                    max: null
                  }
                }
              ]
            },
            {
              id: 3002,
              title: "نام",
              label: "نام",
              action: "mdi-account",
              items: [
                {
                  title: "نام",
                  label: "نام",
                  placeholder: "مثال: علی",
                  optional: false,
                  action: true,
                  type: "text",
                  setting: {
                    regex: ["persian"],
                    min: null,
                    max: null
                  }
                }
              ]
            },
            {
              id: 3003,
              title: "نام خانوادگی",
              label: "نام خانوادگی",
              action: "mdi-account-tie",
              items: [
                {
                  title: "نام خانوادگی",
                  label: "نام خانوادگی",
                  placeholder: "مثال: محمدی",
                  optional: false,
                  action: true,
                  type: "text",
                  setting: {
                    regex: ["persian"],
                    min: null,
                    max: null
                  }
                }
              ]
            },
            {
              id: 3004,
              title: "شماره موبایل",
              label: "شماره موبایل",
              action: "mdi-cellphone",
              items: [
                {
                  title: "شماره موبایل",
                  label: "شماره موبایل",
                  placeholder: "09xxxxxxxxx",
                  optional: false,
                  action: true,
                  type: "text",
                  setting: {
                    regex: ["mobile", "number"],
                    min: 11,
                    max: 11
                  }
                }
              ]
            },
            {
              id: 3005,
              title: "کد ملی",
              label: "کد ملی",
              action: "mdi-card-account-details-outline",
              items: [
                {
                  title: "کد ملی",
                  label: "کد ملی",
                  placeholder: "۱۰ رقم بدون خط تیره",
                  optional: true,
                  action: true,
                  type: "text",
                  setting: {
                    regex: ["meliCode"],
                    min: 10,
                    max: 10
                  }
                }
              ]
            },
            {
              id: 3006,
              title: "واحد / دپارتمان",
              label: "واحد / دپارتمان",
              action: "mdi-domain",
              items: [
                {
                  title: "واحد / دپارتمان",
                  label: "واحد سازمانی",
                  placeholder: "یک مورد را انتخاب کنید",
                  optional: true,
                  action: true,
                  type: "select",
                  selectItems: [
                    "اداری و مالی",
                    "فنی و مهندسی",
                    "فروش و بازاریابی",
                    "پشتیبانی"
                  ],
                  setting: { regex: [], min: null, max: null }
                }
              ]
            },
            {
              id: 3007,
              title: "سمت شغلی",
              label: "سمت شغلی",
              action: "mdi-briefcase-outline",
              items: [
                {
                  title: "سمت شغلی",
                  label: "سمت شغلی",
                  placeholder: "مثال: کارشناس نرم‌افزار",
                  optional: true,
                  action: true,
                  type: "text",
                  setting: {
                    regex: ["persian"],
                    min: null,
                    max: null
                  }
                }
              ]
            }
          ]
        },

        // اطلاعات پایه شرکت و شیفت‌ها
        CompanyAttendanceBaseInfo: {
          organizationName: "نام سازمان / شرکت شما",
          subOrgan: "سامانه هوشمند ثبت تردد پرسنل",
          userName: "",
          workField: "",
          phoneNumber: [{ number: "09131111111", text: "مدیریت" }],
          companyNumber: "",
          companyNumberName: "",
          allowedRadius: 100,
          shifts: [
            { id: 1, name: "شیفت صبح", startTime: "08:00", endTime: "16:00", active: true }
          ],
          address: "تهران، خیابان شریعتی ، بعد از پل سید خندان، بن بست خندان ، پلاک",
          coordinates: [51.420296, 35.732379],
          image: "/media/cr_logo.webp"
        },

        pallete: {
          headColor: "linear-gradient(to right , #1b8d39 0%, #0d5f23 100%)",
          bodyColor: "linear-gradient(to top left , #FEFEFE, #E6F7E5)",
          textColor: "#2c3e50",
          borderColor: "#e0e0e0"
        }
      },

      specialInfo: [
        {
          name: "CompanyAttendanceBaseInfo",
          value: "",
          title: "اطلاعات شرکت و شیفت‌های کاری",
          subtitle: "تنظیم موقعیت جغرافیایی، شعاع مجاز و ساعت شیفت‌ها",
          icon: "domain",
          model: "CompanyAttendanceBaseInfo"
        },
        {
          name: "AttendanceActionSettings",
          value: "",
          title: "تنظیم دکمه‌های عملیات تردد",
          subtitle: "فعال/غیرفعال‌سازی، تغییر نام و مرتب‌سازی کلیدهای اسکن",
          icon: "gesture-tap-button",
          model: "AttendanceActionSettings",
          settings: {
            notColor: true
          }
        },
        {
          name: "AttendanceRegistrationFields",
          value: "",
          title: "فیلدهای فرم ثبت اطلاعات پرسنل",
          subtitle: "تنظیم آیتم‌های دریافت اطلاعات و اعتبارسنجی پرسنل",
          icon: "form-select",
          model: "AttendanceRegistrationFields",
          settings: {
            notColor: true
          }
        },
        {
          name: "colorPallete",
          value: "",
          title: "انتخاب رنگ و قالب ظاهری",
          subtitle: "شخصی‌سازی تم صفحه ثبت تردد پرسنل",
          icon: "format-color-fill",
          model: "pallete"
        }
      ],

      qrSvgDataUrl: ""
    };
  },

  watch: {
    "$i18n.locale"(newLocale, oldLocale) {
      if (newLocale !== oldLocale) {
        localStorage.setItem("language", newLocale);
      }
    }
  },

  mounted() {
    const savedLanguage = getLanguageCookie() || "fa";
    this.$i18n.locale = savedLanguage;
  },

  computed: {
    fullLink() {
      return (this.createdDomain?.replace("/", "") || "") + "/" + (this.createdId || "");
    }
  },

  methods: {
    ...mapActions("local", [
      "updateQrInfo",
      "updateQridentifier",
      "updateQrDomain",
      "updateQrId"
    ]),

    markQr() {
      if (
        !this.dtUrl ||
        typeof this.$refs["address-field"].dtUrlRule(this.dtUrl) !== "boolean"
      ) {
        this.$toast.clear();
        this.$toast.error("آدرس وارد شده صحیح نمی‌باشد!");
        return;
      }

      this.loading = true;
      let obj = {
        type: "attendanceqr",
        qrType: "dynamic",
        title: this.cardTexts.visitName,
        domain_id: this.domainId,
        data: JSON.stringify({
          theme: "",
          data: this.cardTexts
        }),
        qr: JSON.stringify(this.qrDesign)
      };

      if (this.dtUrl && this.dtUrl.length > 0) {
        obj.identifier = this.dtUrl;
      }

      this.$api
        .post("/v1/testQr/store", obj)
        .then(({ data }) => {
          this.loading = false;
          this.createdDomain = this.$refs["address-field"].destItems.find(
            (item) => item.id === this.domainId
          ).name;
          this.createdId = data.data.identifier;
          this.info = data.data;

          this.updateQrInfo(data.data);
          this.updateQridentifier(data.data.identifier);
          this.updateQrDomain(data.data.domain_id);
          this.updateQrId(data.data.id);

          this.$toast.success("کیوآر ثبت تردد پرسنل با موفقیت ایجاد شد");

          if (this.e6 === 1) {
            this.$nextTick(() => {
              setTimeout(() => {
                this.$refs.qrCanvas.appendCanvas(data.data.link);
              }, 500);
              setTimeout(() => {
                this.qrUpdate(false);
              }, 1000);
            });
          }
        })
        .catch((error) => {
          const response = error.response;
          if (response?.status === 422) {
            this.$modal.error("خطا", response.data.message);
          }

          const errorMap = {
            "The آدرس کیوآر has already been taken.": "errors.qr_address_taken"
          };

          if (response?.data?.errors) {
            const backendErrors = response.data.errors;
            const translatedErrors = {};

            Object.entries(backendErrors).forEach(([fieldKey, fieldMessages]) => {
              try {
                translatedErrors[fieldKey] = fieldMessages.map((msg) => {
                  const key = errorMap[msg];
                  return key ? this.$t(key) : msg;
                });
                const msg = fieldMessages[0];
                const key = errorMap[msg];
                this.$toast.error(key ? this.$t(key) : msg, { timeout: 3000 });
              } catch (e) {
                console.error("Error in mapping translation: ", e);
              }
            });

            this.errors = translatedErrors;
          } else {
            this.$toast.error(this.$t("qr_creation_failed"));
          }

          let el = document.getElementById("qr-address");
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    qrUpdate(final = false) {
      if (final || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }

      const data = new FormData();
      data.append("type", "attendanceqr");
      data.append("image", this.qrSvgDataUrl);
      data.append("qrType", "dynamic");
      data.append("domain", this.createdDomain || "");
      data.append("identifier", this.createdId || "");
      data.append("qr_id", this.info?.qrId);
      data.append("_method", "PUT");
      data.append("qr", JSON.stringify(this.qrDesign));
      data.append(
        "data",
        JSON.stringify({
          theme: this.theme || "",
          data: this.cardTexts
        })
      );

      this.$api
        .post("/v1/testQr/update", data)
        .then(() => {
          if (final || !this.AutoSave) {
            this.$toast.success("تنظیمات کیوآر حضور و غیاب به‌روزرسانی شد");
          }

          if (this.e6 > 1) {
            if (final) {
              this.goto("qr/list");
            }
          } else {
            this.e6 += 1;
          }
        })
        .catch(() => {
          this.loading = false;
          this.isAutoSaving = false;
        })
        .finally(() => {
          this.loading = false;
          this.isAutoSaving = false;
        });
    }
  }
};
</script>

<style scoped>
.v-tab--active {
  background-color: var(--v-primary-base) !important;
  border-radius: 50px;
  color: white !important;
}
.sticky-md {
  position: -webkit-sticky;
  position: sticky;
  z-index: 2;
}
</style>
